(function () {
  'use strict';

  const MODAL_ID = 'product-gallery-grid-modal';

  function getModal() {
    return document.getElementById(MODAL_ID);
  }

  function openModal() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var closeBtn = modal.querySelector('.gallery-grid-modal__close');
    if (closeBtn) closeBtn.focus();

    if (window.gtag) {
      gtag('event', 'gallery_grid_open', {
        'product_title': document.title,
        'page_location': window.location.href
      });
    }
  }

  function closeModal() {
    var modal = getModal();
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function goToSlide(index) {
    if (window.gtag) {
      gtag('event', 'gallery_grid_select', {
        'slide_index': index + 1,
        'page_location': window.location.href
      });
    }

    var gallery = document.querySelector('product-gallery');
    if (gallery) {
      var slides = document.querySelectorAll('.product__media-list .slider__slide');
      if (slides[index]) {
        slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        slides.forEach(function (s) { s.classList.remove('is-active'); });
        slides[index].classList.add('is-active');
        var current = document.querySelector('.slider-counter--current');
        if (current) current.textContent = index + 1;
      }
    }

    closeModal();
  }

  function init() {
    var modal = getModal();
    if (!modal) return;

    document.querySelectorAll('.product-gallery-grid-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal();
      });
    });

    var closeBtn = modal.querySelector('.gallery-grid-modal__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', closeModal);
    }

    var overlay = modal.querySelector('.gallery-grid-modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });

    modal.querySelectorAll('.gallery-grid-modal__item').forEach(function (item) {
      item.addEventListener('click', function () {
        var index = parseInt(this.getAttribute('data-index'), 10);
        goToSlide(index);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();